import { typographyToCss } from 'shared/lib/mui';
import { css } from 'styled-components';

// The calendar-accounts rows and the sync-tasks rows are separate sections that
// must line up column-for-column, so they share one track list.
export const calendarSettingsColumns = css`
  display: grid;
  grid-template-columns:
    minmax(0, 1.4fr) 1.6em minmax(0, 1.4fr) minmax(0, 1fr) minmax(0, 1fr)
    1.6em;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};
`;

export const calendarSettingsColumnLabel = css`
  ${({ theme }) => typographyToCss(theme.typography.buttonSmall)};
  color: ${({ theme }) => theme.palette.text.secondary};
`;

// Pulled left by its own padding so the icon lines up with the section's content edge.
export const calendarSettingsAddButton = css`
  justify-self: start;
  margin-left: -${({ theme }) => theme.spacing(1.75)};
`;
